(() => {
  const readVariants = () => {
    const node = document.querySelector('[data-cv-s340-hb3-controller] [data-cv-s340-hb3-variants]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch (_) { return []; }
  };

  const initFaq = (root = document) => {
    root.querySelectorAll('[data-cv-s340-hb3-faq]:not([data-cv-s340-hb3-ready])').forEach((list) => {
      list.dataset.cvS340HB3Ready = 'true';
      const buttons = Array.from(list.querySelectorAll('[data-cv-s340-hb3-faq-button]'));

      const setOpen = (button, open) => {
        const item = button.closest('[data-cv-s340-hb3-faq-item]');
        const answer = document.getElementById(button.getAttribute('aria-controls') || '');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (item) item.dataset.open = open ? 'true' : 'false';
        if (answer) answer.hidden = !open;
      };

      buttons.forEach((button) => setOpen(button, false));

      list.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cv-s340-hb3-faq-button]');
        if (!button || !list.contains(button)) return;
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        if (willOpen && list.dataset.multiple !== 'true') {
          buttons.forEach((other) => { if (other !== button) setOpen(other, false); });
        }
        setOpen(button, willOpen);
      });

      list.addEventListener('keydown', (event) => {
        const button = event.target.closest('[data-cv-s340-hb3-faq-button]');
        if (!button || !list.contains(button)) return;
        if (['Enter', ' ', 'Spacebar'].includes(event.key)) {
          event.preventDefault();
          const willOpen = button.getAttribute('aria-expanded') !== 'true';
          if (willOpen && list.dataset.multiple !== 'true') {
            buttons.forEach((other) => { if (other !== button) setOpen(other, false); });
          }
          setOpen(button, willOpen);
          return;
        }
        const index = buttons.indexOf(button);
        let target = null;
        if (event.key === 'ArrowDown') target = buttons[(index + 1) % buttons.length];
        if (event.key === 'ArrowUp') target = buttons[(index - 1 + buttons.length) % buttons.length];
        if (event.key === 'Home') target = buttons[0];
        if (event.key === 'End') target = buttons[buttons.length - 1];
        if (target) { event.preventDefault(); target.focus(); }
      });
    });
  };

  const initFinalCta = (root = document) => {
    root.querySelectorAll('[data-cv-s340-hb3-final-cta]:not([data-cv-s340-hb3-ready])').forEach((cta) => {
      cta.dataset.cvS340HB3Ready = 'true';
      const finalButton = cta.querySelector('[data-cv-s340-hb3-final-add]');
      const finalPrice = cta.querySelector('[data-cv-s340-hb3-final-price]');
      const status = cta.querySelector('[data-cv-s340-hb3-final-status]');
      const purchase = document.querySelector('[data-cv-s340-hb3-controller]');
      const variantInput = purchase?.querySelector('[data-cv-s340-hb3-variant-input]');
      const variants = readVariants();
      if (!finalButton || !purchase || !variantInput) return;

      const currentVariant = () => variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
      const sync = () => {
        const variant = currentVariant();
        if (finalPrice && variant?.priceFormatted) finalPrice.textContent = variant.priceFormatted;
        const mainButton = purchase.querySelector('[data-cv-s340-hb3-add]');
        const busy = mainButton?.getAttribute('aria-busy') === 'true' || mainButton?.hasAttribute('data-added');
        const unavailable = !variant?.available;
        finalButton.disabled = Boolean(busy || unavailable);
        finalButton.setAttribute('aria-disabled', busy || unavailable ? 'true' : 'false');
        finalButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (busy && status) status.textContent = 'Adding through the secure product form…';
      };
      variantInput.addEventListener('change', sync);
      finalButton.addEventListener('click', () => {
        if (status) status.textContent = 'Adding through the secure product form…';
      });
      new MutationObserver(sync).observe(purchase, {attributes:true, childList:true, characterData:true, subtree:true});
      sync();
    });
  };

  const init = (root = document) => { initFaq(root); initFinalCta(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();